import { render, staticRenderFns } from "./ReportCogs.vue?vue&type=template&id=7a64d28a"
import script from "./ReportCogs.vue?vue&type=script&lang=js"
export * from "./ReportCogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports